import { CSSProperties, FC, useState } from 'react';
import './Modal.css';
import SolidButton from '../../components/SolidButton/SolidButton';

export interface ModalButtonInfo {
  /** The action to be performed when the button is clicked */
  action: () => void;
  /** The text to be displayed on the button */
  text: string;
  /** To be set as the value of the CSS `background-color`, examples; hex string, rgb(n,n,n), var(--my-color-var) */
  color: string;
}

interface ModalProps {
  /** The action to be performed if the user selects the X close button in the upper right corner */
  onClose: () => void;
  primaryActionButtonInfo?: ModalButtonInfo;
  additonalActionButtonInfos?: ModalButtonInfo[];
  children?: React.ReactNode;
  message?: string;
  showCloseButton?: boolean;
  allowBackgroundClose?: boolean;
  modalStyle?: React.CSSProperties;
}

const Modal: FC<ModalProps> = ({onClose, primaryActionButtonInfo, additonalActionButtonInfos, children, message, showCloseButton = true, allowBackgroundClose=false, modalStyle}:ModalProps) => {

  const [animating, setAnimating] = useState<string>('opening')

  const handleClose = () => {
    setAnimating('closing')
    setTimeout(() => {
      onClose()
    },750)
  }

  const handleSubmit = () => {
    setAnimating('closing')
    setTimeout(() => {
      primaryActionButtonInfo!.action()
    },750)
  }

  const modalBoxStyling: CSSProperties = {}
  if (!showCloseButton) {
    modalBoxStyling.pointerEvents = 'none'
  }

  return (
    <div className={`modal-container${animating.length > 0 ? ` ${animating}` : ''}`} onClick={(e) => {
      const target = e.target as HTMLElement
      if (allowBackgroundClose && target.className === "modal-container opening") {
        handleClose()
      }
    }}>
      <div className={`modal-box${animating.length > 0 ? ` ${animating}` : ''}`} style={{...modalStyle,...modalBoxStyling}}>
        {showCloseButton && 
          <div className="modal-header">
            <div className="close-btn" onClick={handleClose}/>
          </div>
        }
        <div className="modal-body">
          {children && children}
          {message && <div className="modal-message">{message}</div>}
        </div>
        {primaryActionButtonInfo &&
          <div className="modal-footer">
            <SolidButton 
              text={primaryActionButtonInfo.text}
              onClick={handleSubmit} 
              padding='14px 30px' 
              color={primaryActionButtonInfo.color}
              style={{borderRadius: '2.5px'}}
            />
            {additonalActionButtonInfos && 
              additonalActionButtonInfos.map((info, index) => {
                return (
                  <SolidButton 
                    key={index}
                    text={info.text}
                    onClick={() => {
                      setAnimating('closing')
                      setTimeout(() => {
                        info.action()
                      },750)
                    }} 
                    padding='14px 30px' 
                    color={info.color}
                    style={{borderRadius: '2.5px'}}
                  />
                )
              })
            }
            </div>
          }
      </div>
    </div>
  )
};

export default Modal;
